import * as yup from 'yup';

export const validacaoFormGrupo = yup.object().shape({
    nome: yup
        .string()
        .max(250, 'O nome da imagem deve ter no máximo 250 caracteres.')
        .required('Campo nome é obrigatório')         
});
